import { AxiosResponse } from 'axios';

import { api } from 'api';
import { PaginatedQuery } from 'features/app/ts/PaginatedQuery';
import { RedemptionReportFilters } from 'features/redemptions/ts/RedemptionReportFilters';
import { IdType } from 'ts/IdType';

export const getRedemptionReportCsvRequest = async (
  params: PaginatedQuery & RedemptionReportFilters
): Promise<AxiosResponse<File>> => {
  const response = await api.get('/orders/redemptions/', {
    responseType: 'blob',
    params: { ...params, report: true },
  });

  const contentDisposition = response.headers['content-disposition'];
  const file = response.data;

  file.name = contentDisposition.split('attachment; filename=')[1];

  return { ...response, data: file };
};

export const cancelCardRequest = async (id: IdType) => api.post(`/orders/gift-cards/cancel/`, { id });
export const getCancelCardSummary = async (id: IdType) =>
  api.get('/orders/gift-cards/cancel-refund-amount/', { params: { id } });
